/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../Interceptor/Interseptor'
import {message} from 'antd'

class CreateProcessCategory extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  submit(e) {
    e.preventDefault()
  }

  createCartStation() {
    let title = document.getElementById('title').value.trim()
    if (title === '') {
      message.error('فیلد های ستاره دار انتخاب شود')
    } else {
      let data = {
        title
      }
      http
        .post(`process-category/create`, data, {})
        .then((res) => {
          if (res.data.error === null) {
            message.success(' با موفقیت اضافه شد')
            setTimeout(() => {
              window.location.assign('/base/deliveryStatus/processCategories')
            }, 3000)
          } else {
            message.error(res.data.description)
          }
        })
        .catch(() => {})
    }
  }

  render() {
    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت فرایندها</li>
            <li>افزودن دسته فرایند</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>افزودن دسته فرایند</p>
            </div>
            <div className="formComponent selectComponent">
              <label>
                عنوان :<span className="requireFiled">*</span>‌
              </label>
              <input type="text" id="title" className="form-control" />
            </div>

            <div className="formComponent selectComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.createCartStation.bind(this)}>
                افزودن
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default CreateProcessCategory
